import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrTooltipIconComponent } from './pr-tooltip-icon.component';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [PrTooltipIconComponent],
  imports: [CommonModule, PrIconModule, TooltipModule.forRoot()],
  exports: [PrTooltipIconComponent],
})
export class PrTooltipIconModule {}
